import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { names, themes, variations } from '@core/constants/icons';
import { CustomIconNames, CustomIconVariations } from '@core/types/icons.type';
import { ThemeService } from 'asksuite-citrus';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CustomIconsRegisterService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private theme: ThemeService,
  ) {}

  register() {
    const icons = this.getIconSrcs();
    for (const cIcon of icons) {
      this.matIconRegistry.addSvgIcon(
        cIcon,
        this.domSanitizer.bypassSecurityTrustResourceUrl(
          `assets/icons/proprietary/${cIcon}.svg`
        ),
      );
    }
  }

  getIcon$(name: CustomIconNames, variations: CustomIconVariations) {
    return  (this.theme.listenThemeChange() as unknown as Observable<string>).pipe(map((theme) => `${theme}-${name}-${variations}`));
  }

  hasIcon(name: string) {
    return names.includes(name as any);
  }

  private getIconSrcs() {
    let _icons = [];

    for (const theme of themes) {
      for (const variation of variations) {
        for (const name of names) {
          _icons.push(`${theme}-${name}-${variation}`);
        }
      }
    }
    return _icons;
  }
}
